import React, { useState } from 'react';
import LazyLoad from 'react-lazyload';
function FeaturesBlocks() {

  let [speakers] = useState({
    Speakers : [
      {
        id: 1,
        name: 'Supratik Chakraborty',
        affiliation: 'IIT Bombay',
        expertise: 'Hardware verification and Reactive Sysnthesis',
        designation: 'Professor',
        image: 'iitb-logo.png',
        profile: 'supratik.jpg',
        page: 'https://www.cse.iitb.ac.in/~supratik/'
      },
      {
        id: 19,
        name: 'R. Govindarajan',
        affiliation: 'IISc Bangalore',
        expertise: 'Machine Architecture and Machine Dependent Optimizations',
        designation: 'Professor',
        image: 'iisc-logo.png',
        profile: 'rgovind.jpg',
        page: 'https://www.csa.iisc.ac.in/~govind/'
      },
      {
        id: 8,
        name: 'Maitreyi Gupta',
        affiliation: 'Qualcomm',
        expertise: 'Hexagon SDK',
        designation: 'Senior Engineer',
        image: 'qcom.png',
        profile: 'maitreyi.jpeg',
        page: 'https://in.linkedin.com/in/maitreyi-gupta-02121994'

      },
      {
        id: 5,
        name: 'Amey Karkare',
        affiliation: 'IIT Kanpur',
        expertise: 'Compilers',
        designation: 'Associate Professor',
        image: 'iitk-logo.png',
        profile: 'amey.jpg',
        page: 'https://www.cse.iitk.ac.in/users/karkare/'
      },
      {
        id: 7,
        name: 'Ravishankar Kolachana',
        affiliation: 'Qualcomm',
        expertise: 'Hexagon Architecture',
        designation: 'Director, Engineering',
        image: 'qcom.png',
        profile: 'ravi.jpg',
        page: 'https://in.linkedin.com/in/ravishankar-kolachana-a8197ba'
      },
      {
        id: 13,
        name: 'Atul Pant',
        affiliation: 'Qualcomm',
        expertise: 'Hexagon SDK',
        designation: 'Qualcomm',
        image: 'qcom.png',
        profile: 'atul.jpeg',
        page: 'https://www.linkedin.com/in/atul-pant-97b937136/'

      },
      {
        id: 11,
        name: 'Madhu Mutyam',
        affiliation: 'IIT Madras',
        expertise: 'Computer Architecture',
        designation: 'Professor',
        image: 'iitm-logo.png',
        profile: 'madhumutyam.jpg',
        page: 'http://www.cse.iitm.ac.in/~madhu/'

      },
      {
        id: 4,
        name: 'Subhajit Roy',
        affiliation: 'IIT Kanpur',
        expertise: 'Software Testing & Verification',
        designation: 'Associate Professor',
        image: 'iitk-logo.png',
        profile: 'subhajit.png',
        page: 'https://www.cse.iitk.ac.in/users/subhajit/'

      },
      {
        id: 7,
        name: 'Abhikrant Sharma',
        affiliation: 'Qualcomm',
        expertise: 'Hexagon Architecture',
        designation: 'Staff Software Engineer',
        image: 'qcom.png',
        profile: 'abhikrant.jpeg',
        page: 'https://www.linkedin.com/in/abhikrant-sharma-79b20735'

      },
	  {
        id: 3,
        name: 'Sushim Srivastava',
        affiliation: 'Qualcomm',
        expertise: 'Industry Perspective on Compilers',
        designation: 'Senior Director, Engineering',
        image: 'qcom.png',
        profile: 'sushim.jpg',
        page: 'https://in.linkedin.com/in/sushim'

      },
      {
        id: 9,
        name: 'Suyog Sarda',
        affiliation: 'Qualcomm',
        expertise: 'Halide',
        designation: 'Staff Engineer',
        image: 'qcom.png',
        profile: 'suyog.jpg',
        page: 'https://in.linkedin.com/in/suyog-sarda-94863933'

      },
	  {
        id: 2,
        name: 'Sunil Simon',
        affiliation: 'IIT Kanpur',
        expertise: 'Mathematical Logic',
        designation: 'Assistant Professor',
        image: 'iitk-logo.png',
        profile: 'sunilsimon.jpg',
        page: 'https://www.cse.iitk.ac.in/users/simon/'

      },
	  {
        id: 12,
        name: 'Y. N. Srikant',
        affiliation: 'IISc Bangalore',
        expertise: 'Compilers',
        designation: 'Professor',
        image: 'iisc-logo.png',
        profile: 'srikant.jpg',
        page: 'https://www.csa.iisc.ac.in/~srikant/'

      },
      {
        id: 6,
        name: 'Abhijat Vichare',
        affiliation: 'ACM India',
        expertise: 'Execution Environments',
        designation: 'Consultant',
        image: 'acm.png',
        profile: 'abhijatvichare.jpg',
        page: 'https://india.acm.org/education/learning/esp/abhijat-vichare'

      }
    ]
  })

  let [organizers] = useState({
    Organizers : [
      {
        id: 1,
        name: 'Gourav Thakar',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'gourav.jpg',
        page: '#organizers'
      },
      {
        id: 2,
        name: 'Sujit Kumar Muduli',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'sujit.jpeg',
        page: 'https://www.cse.iitk.ac.in/users/smuduli/'
      },
      {
        id: 8,
        name: 'Yash Kumar',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'yashk.jpg',
        page: 'https://www.cse.iitk.ac.in/users/yashk/'

      },
      {
        id: 5,
        name: 'Nitesh Trivedi',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'nitesh.jpeg',
        page: '#organizers'

      },
      {
        id: 7,
        name: 'Prantik Chatterjee',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'prantik.jpeg',
        page: 'https://www.linkedin.com/in/prantik-chatterjee-b7962416a/'

      },
      {
        id: 11,
        name: 'Priyanka Golia',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'priyank.png',
        page: 'https://priyanka-golia.github.io/'

      },
      {
        id: 4,
        name: 'Pankaj Kumar Kalita',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'pankaj.jpeg',
        page: 'https://www.cse.iitk.ac.in/users/pkalita/'

      },
      {
        id: 3,
        name: 'Vishal Singh',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'vishal.png',
        page: 'https://www.cse.iitk.ac.in/users/vshlsng/'

      },
      {
        id: 9,
        name: 'Sumit Lahiri',
        affiliation: 'IIT Kanpur',
        expertise: '',
        designation: '',
        image: 'iitk-logo.png',
        profile: 'sumit.jpeg',
        page: 'https://www.linkedin.com/in/sumit-lahiri/'

      },
    ]
  })
  return (
    <section className="relative" data-aos="zoom-y-out" id="speakers">
      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div className="absolute inset-0 top-1/2 md:mt-24 lg:mt-0 bg-gray-100 pointer-events-none" aria-hidden="true"></div>
      <div className="absolute left-0 right-0 bottom-0 m-auto w-px p-px h-20 bg-gray-200 transform translate-y-1/2"></div>
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <h2 className="h2 mb-4">Invited Speakers</h2>
            <p className="text-xl text-gray-600">We are have an exciting row of talks and sessions planned ahead.</p>
          </div>    
          {/* Items */}
          <div className="max-w-sm mx-auto grid gap-6 md:grid-cols-2 lg:grid-cols-2 items-start md:max-w-2xl lg:max-w-none ">
          {Object.values(speakers).map((speaker, idx) => (
              speaker.map((objs) =>  <div key={objs.id}
            className="w-full h-full transition duration-500 ease-in-out relative flex flex-col md:flex-row rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto
            border border-white bg-white ring-4 ring-offset-2 ring-offset-green-800 ring-green-100 cursor-pointer" onClick={(e) => {
                e.preventDefault()
                window.location.href = objs.page;
              }}>
            <div className="bg-white grid place-items-center">
              <LazyLoad height={32}>
              <img src={require(`../images/${objs.profile}`).default} alt="profile"
                   className="rounded-xl w-36 h-32" />
              </LazyLoad>
            </div>
              <div className="w-full bg-white flex flex-col space-y-2 p-3">
                
                <div className="flex justify-between item-center">
                  <p className="text-xl font-bold leading-snug">{objs.name}</p>
                  {/*<span>*/}
                  {/*      <img className="rounded-full w-9 h-9 max-w-none" alt="A"*/}
                  {/*           src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg"/>*/}
                  {/*                  <div*/}
                  {/*                      className="bg-green-300 px-1 py-1 rounded-full text-xs font-bold text-gray-800 shadow-xl">*/}
                  {/*    {objs.affiliation}</div>*/}
                  {/*</span>*/}
                  <div className="relative rounded-full text-black font-semibold text-xs flex align-center items-center
                  cursor-pointer active:bg-gray-300 transition duration-300 ease">
                    {objs.image !== '' && <LazyLoad height={7}><img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                                                   src={require(`../images/${objs.image}`).default}/></LazyLoad>}
                    <span className="flex items-center subpixel-antialiased text-sm px-2 py-2">
                      {objs.affiliation}
                    </span>
                  </div>
                </div>
                <p className="md:text-lg text-gray-500 text-base">{objs.expertise}</p>
                <p className="text-gray-500 font-bold">{objs.designation}</p>
              </div>
            </div>)
            ))
          }
          </div>
        </div>
      </div>
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6" id="organizers">
        <div className="py-2 md:py-2">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <h2 className="h2 mb-4">Organizing Team</h2>
          </div>
          {/* Items */}
          <div
              className="max-w-sm mx-auto grid gap-4 md:grid-cols-3 lg:grid-cols-3 items-start md:max-w-2xl lg:max-w-none ">
            {Object.values(organizers).map((speaker, idx) => (
                speaker.map((objs) => <div key={objs.id}
                    className="w-full h-28 transition duration-500 ease-in-out relative flex flex-row md:flex-row rounded
                    shadow-xl hover:shadow-lg hover:border-gray-200 p-2 max-w-xs md:max-w-3xl mx-auto
            border border-white bg-white ring-4 ring-offset-2 ring-offset-blue-800 ring-blue-200 cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault()
                      window.location.href = objs.page;
                    }}>
                  <div className="bg-white grid place-items-center">
                    <LazyLoad height={20}>
                    <img src={require(`../images/${objs.profile}`).default} alt="profile"
                         className="rounded-xl w-24 h-20"/></LazyLoad>
                  </div>
                  <div className="w-full bg-white flex flex-col space-y-2 p-3">
                    <div className="flex justify-between item-center">
                      <p className="text-xl font-bold leading-snug">{objs.name}</p>
                    </div>
                    <div className="relative rounded-full text-black font-semibold text-xs flex align-center items-center
                  cursor-pointer active:bg-gray-300 transition duration-300 ease">
                      {objs.image !== '' && <LazyLoad height={7}><img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                                                     src={require(`../images/${objs.image}`).default}/></LazyLoad>}
                      <span className="flex items-center subpixel-antialiased text-sm px-2 py-2">
                      {objs.affiliation}
                    </span>
                    </div>
                    <p className="md:text-lg text-gray-500 text-base">{objs.expertise}</p>
                    <p className="text-gray-500 font-bold">{objs.designation}</p>
                  </div>
                </div>)
            ))
            }
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturesBlocks;
